import { FeatureRouterLinkResolverService } from './feature-router-link-resolver.service';
import * as i0 from "@angular/core";
import * as i1 from "./feature-router-link-resolver.service";
export let RouterLinkResolverPipe = /*#__PURE__*/(() => {
  class RouterLinkResolverPipe {
    constructor(linkResolver) {
      this.linkResolver = linkResolver;
    }
    transform(valueOrName, optName) {
      const name = optName || valueOrName;
      const value = optName ? valueOrName : null;
      return this.linkResolver.resolveRouterLink(name, value);
    }
    static {
      this.ɵfac = function RouterLinkResolverPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RouterLinkResolverPipe)(i0.ɵɵdirectiveInject(i1.FeatureRouterLinkResolverService, 16));
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "resolveRouterLink",
        type: RouterLinkResolverPipe,
        pure: true
      });
    }
  }
  return RouterLinkResolverPipe;
})();